var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"session-detail"},[_c('agenda-detail',{key:_vm.$route.params.sessionId})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }